import React, { useState } from 'react';
import { Send, X } from 'lucide-react';
import { toast } from 'sonner';
import { api, errText } from '@/lib/api';
import { Button } from '@/components/ui/button';
import { Textarea } from '@/components/ui/textarea';

export function DraftCard({ draft, windowOpen, onDone }) {
  const [text, setText] = useState(draft.body);
  const [busy, setBusy] = useState(false);
  const ai = draft.ai || {};

  const act = async (path, body) => {
    setBusy(true);
    try { await api.post(`/whatsapp/messages/${draft.id}/${path}`, body); onDone(); } catch (e) { toast.error(errText(e)); } finally { setBusy(false); }
  };

  return (
    <div className="border-t border-amber-500/30 bg-amber-500/5 p-4 space-y-2" data-testid="whatsapp-draft">
      <div className="flex items-center justify-between text-xs">
        <span className="font-medium text-amber-300">Borrador del agente IA · confianza {Math.round((ai.confidence || 0) * 100)}%</span>
        {ai.kb_used?.length > 0 && <span className="text-[hsl(var(--muted-foreground))] truncate max-w-[50%]">Base: {ai.kb_used.map((k) => k.title).join(', ')}</span>}
      </div>
      {ai.reasoning && <div className="text-[11px] text-[hsl(var(--muted-foreground))]" data-testid="whatsapp-draft-reasoning">{ai.reasoning}</div>}
      <Textarea rows={5} value={text} onChange={(e) => setText(e.target.value)} data-testid="whatsapp-draft-text" />
      <div className="flex justify-end gap-2">
        <Button size="sm" variant="ghost" onClick={() => act('discard')} disabled={busy} data-testid="whatsapp-draft-discard"><X className="h-4 w-4 mr-1" />Descartar</Button>
        <Button size="sm" onClick={() => act('approve', { body: text })} disabled={busy || !windowOpen || !text.trim()} data-testid="whatsapp-draft-send">
          <Send className="h-4 w-4 mr-1" />{text === draft.body ? 'Aprobar y enviar' : 'Enviar editado'}
        </Button>
      </div>
    </div>
  );
}
